import * as React from 'react';

const useTimedAlerts = () => {
  const [errorMessage, setErrorMessage] = React.useState<string>('');
  const [successMessage, setSuccessMessage] = React.useState<string>('');

  React.useEffect(() => {
    const timer = setTimeout(() => {
      setSuccessMessage('');
    }, 5000);
    return () => clearTimeout(timer);
  }, [successMessage]);

  React.useEffect(() => {
    const timer = setTimeout(() => {
      setErrorMessage('');
    }, 5000);
    return () => clearTimeout(timer);
  }, [errorMessage]);

  return {
    successMessage,
    setSuccessMessage,
    errorMessage,
    setErrorMessage
  };
};

export default useTimedAlerts;
